/**
 * @generated SignedSource<<16aafc2e6239959babb43f578e2a71bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PersonSidePanel_person$data = {
  readonly contracts: ReadonlyArray<{
    readonly end_date: string | null | undefined;
    readonly id: number;
    readonly job_title: string | null | undefined;
    readonly role: {
      readonly id: number;
      readonly name: string;
    };
    readonly start_date: string | null | undefined;
  }>;
  readonly email: string | null | undefined;
  readonly first_name: string;
  readonly id: number;
  readonly image_key: string | null | undefined;
  readonly last_name: string;
  readonly people_notes_aggregate: {
    readonly aggregate: {
      readonly count: number;
    } | null | undefined;
  };
  readonly team: {
    readonly id: number;
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"EditPersonForm_person" | "PersonActionButtons_person" | "PersonCustomEditor_person" | "PersonSidePanelContract_person" | "PersonSidePanelDetails_person" | "PersonSidePanelNotes_person">;
  readonly " $fragmentType": "PersonSidePanel_person";
};
export type PersonSidePanel_person$key = {
  readonly " $data"?: PersonSidePanel_person$data;
  readonly " $fragmentSpreads": FragmentRefs<"PersonSidePanel_person">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PersonSidePanel_person",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "first_name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last_name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image_key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "teams",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "contracts",
      "kind": "LinkedField",
      "name": "contracts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "start_date",
          "args": null,
          "kind": "ScalarField",
          "name": "start_date_runn",
          "storageKey": null
        },
        {
          "alias": "end_date",
          "args": null,
          "kind": "ScalarField",
          "name": "end_date_runn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "roles",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "job_title",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "people_notes_aggregate",
      "kind": "LinkedField",
      "name": "people_notes_aggregate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "people_notes_aggregate_fields",
          "kind": "LinkedField",
          "name": "aggregate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PersonSidePanelDetails_person"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PersonCustomEditor_person"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PersonActionButtons_person"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditPersonForm_person"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PersonSidePanelContract_person"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PersonSidePanelNotes_person"
    }
  ],
  "type": "people",
  "abstractKey": null
};
})();

(node as any).hash = "909b8de828052ccd07fd736fd5bb691e";

export default node;
